var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.label)?_c('span',{class:['reading-flag-pill', _vm.config.class],attrs:{"title":_vm.legacyTooltip}},[_vm._v(_vm._s(_vm.config.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }